<template>
  <div>
    <CRow :class="$hasAuthor('ROLE_ADMIN') ? '' : 'mt-4'">
      <CCol md="12">
        <CCard class="mt-3">
          <CCardHeader color="light" class="d-inline-flex justify-content-between align-items-center">
            <div>
              <i class="fa fa-tachometer"></i>
              <strong> Thống kê thiết bị </strong>
            </div>
            <!--            <small>theo chức vụ</small>-->
            <CButton color="primary" @click="loadDataStatistic()">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
                <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
                </BaseSelect>
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
                <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12" class="mt-4">
                <CCard class="dashboard-device-card border-0 shadow-sm">
                  <CCardHeader class="dashboard-device-header bg-white border-bottom-0 pb-0">
                    <div class="dashboard-device-header-row">
                      <div class="dashboard-device-header-main">
                        <div class="dashboard-device-header-icon mr-3">
                          <i class="fa fa-desktop"></i>
                        </div>
                        <div>
                          <h5 class="mb-0 font-weight-bold text-dark">Thiết bị</h5>
                          <p class="text-muted small mb-0 mt-1" v-if="statistic && statistic.devices">
                            Theo bộ lọc địa bàn · <strong>{{ statistic.devices.total }}</strong> thiết bị
                          </p>
                        </div>
                      </div>
                      <div class="dashboard-device-header-actions">
                        <div class="dashboard-device-visibility-panel">
                          <label
                            class="dashboard-device-toggle-item"
                            :class="{ 'is-active': dashboardView.showKpi }"
                            v-c-tooltip="{ content: 'Hiển thị KPI', placement: 'bottom' }"
                          >
                            <input
                              type="checkbox"
                              :checked="dashboardView.showKpi"
                              @change="toggleDashboardSection('showKpi', $event.target.checked)"
                            />
                            <span class="dashboard-toggle-icon">
                              <i class="fa fa-th-large"></i>
                            </span>
                          </label>
                          <label
                            class="dashboard-device-toggle-item"
                            :class="{ 'is-active': dashboardView.showChart }"
                            v-c-tooltip="{ content: 'Hiển thị biểu đồ', placement: 'bottom' }"
                          >
                            <input
                              type="checkbox"
                              :checked="dashboardView.showChart"
                              @change="toggleDashboardSection('showChart', $event.target.checked)"
                            />
                            <span class="dashboard-toggle-icon">
                              <i class="fa fa-pie-chart"></i>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </CCardHeader>
                  <CCardBody class="pt-3" v-if="statistic && statistic.devices">
                    <div class="dashboard-kpi-grid" v-if="dashboardView.showKpi">
                      <div
                        v-for="kpi in deviceKpis"
                        :key="kpi.key"
                        class="dashboard-kpi-tile"
                        :class="'dashboard-kpi-tile--' + kpi.variant"
                      >
                        <div class="dashboard-kpi-tile__icon">
                          <i :class="'fa ' + kpi.icon"></i>
                        </div>
                        <div class="dashboard-kpi-tile__body">
                          <div class="dashboard-kpi-tile__label">{{ kpi.label }}</div>
                          <div class="dashboard-kpi-tile__value">
                            {{ kpi.value }}
                            <span class="dashboard-kpi-tile__pct">/ {{ kpi.pct }}%</span>
                          </div>
                          <div class="progress dashboard-kpi-tile__bar">
                            <div
                              class="progress-bar"
                              role="progressbar"
                              :class="kpi.progressClass"
                              :style="{ width: Math.min(100, kpi.pct) + '%' }"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <CRow :class="dashboardView.showKpi ? 'mt-3 mt-lg-4' : ''" v-if="dashboardView.showChart">
                      <CCol xs="12" lg="6" class="mb-3 mb-lg-0">
                        <div class="dashboard-chart-panel h-100">
                          <div class="dashboard-chart-panel__head">
                            <span class="dashboard-chart-panel__badge dashboard-chart-panel__badge--conn">
                              <i class="fa fa-rss"></i>
                            </span>
                            <div>
                              <div class="dashboard-chart-panel__title">Kết nối thiết bị</div>
                              <div class="dashboard-chart-panel__subtitle">Đang kết nối so với mất kết nối</div>
                            </div>
                          </div>
                          <div class="dashboard-chart-panel__canvas">
                            <div class="dashboard-chart-panel__body">
                              <div class="dashboard-chart-panel__donut">
                                <CChartDoughnut
                                  :datasets="chartConnectionDatasets"
                                  :labels="chartConnectionLabels"
                                  :options="chartDoughnutOptions"
                                />
                              </div>
                              <div class="dashboard-chart-panel__stats">
                                <div
                                  v-for="item in connectionStats"
                                  :key="item.key"
                                  class="dashboard-stat-row"
                                >
                                  <span class="dashboard-stat-dot" :style="{ backgroundColor: item.color }"></span>
                                  <span class="dashboard-stat-label">{{ item.label }}</span>
                                  <span class="dashboard-stat-value">{{ item.value }}</span>
                                  <span class="dashboard-stat-pct">{{ item.pct }}%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </CCol>
                      <CCol xs="12" lg="6">
                        <div class="dashboard-chart-panel h-100">
                          <div class="dashboard-chart-panel__head">
                            <span class="dashboard-chart-panel__badge dashboard-chart-panel__badge--cast">
                              <i class="fa fa-bullhorn"></i>
                            </span>
                            <div>
                              <div class="dashboard-chart-panel__title">Trạng thái phát sóng</div>
                              <div class="dashboard-chart-panel__subtitle">Đang phát · Tạm dừng · Không phát</div>
                            </div>
                          </div>
                          <div class="dashboard-chart-panel__canvas">
                            <div class="dashboard-chart-panel__body">
                              <div class="dashboard-chart-panel__donut">
                                <CChartDoughnut
                                  :datasets="chartBroadcastDatasets"
                                  :labels="chartBroadcastLabels"
                                  :options="chartDoughnutOptions"
                                />
                              </div>
                              <div class="dashboard-chart-panel__stats">
                                <div
                                  v-for="item in broadcastStats"
                                  :key="item.key"
                                  class="dashboard-stat-row"
                                >
                                  <span class="dashboard-stat-dot" :style="{ backgroundColor: item.color }"></span>
                                  <span class="dashboard-stat-label">{{ item.label }}</span>
                                  <span class="dashboard-stat-value">{{ item.value }}</span>
                                  <span class="dashboard-stat-pct">{{ item.pct }}%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCard>
                <CCard v-if="statistic && statistic.files">
                  <CCardHeader color="light">
                    <i class="fa fa-file"></i>
                    <strong> Bản tin biên tập </strong>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol sm="2">
                        <h6 id="traffic" class="card-title mb-2">Từ ngày - đến ngày</h6>
                        <DatePicker id="datepicker" v-model="dateRange" locale="vi"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" :popover="{ visibility: 'click' }" is-range
                          class="datepicker">
                          <template v-slot="{ inputValue, inputEvents }">
                            <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                              class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
                          </template>
                        </DatePicker>
                      </CCol>
                      <!--                                    <CCol sm="7" class="d-none d-md-block">-->
                      <!--                                      <CButtonGroup class="float-right mr-3">-->
                      <!--                                        <CButton-->
                      <!--                                          color="outline-secondary"-->
                      <!--                                          v-for="(value, key) in ['Day', 'Month', 'Year']"-->
                      <!--                                          :key="key"-->
                      <!--                                          class="mx-0"-->
                      <!--                                          :pressed="value === selected ? true : false"-->
                      <!--                                          @click="selected = value">-->
                      <!--                                          {{value}}-->
                      <!--                                        </CButton>-->
                      <!--                                      </CButtonGroup>-->
                      <!--                                    </CCol>-->
                    </CRow>
                    <MainChart style="height:350px;margin-top:40px;" :items="statistic.files" />
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import MainChart from "@/views/base/MainChart";
import { DatePicker } from "v-calendar";
import BaseSelect from "@/views/base/BaseSelect2";
import { CChartDoughnut } from "@coreui/vue-chartjs";

export default {
  name: 'Dashboard',
  components: { BaseSelect, MainChart, BaseFormLoading, DatePicker, CChartDoughnut },
  data() {
    let that = this;
    return {
      loading: { value: false },
      dateRange: {
        start: that.$helper.subtractNowDate(15),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: '',
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: '',
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      dashboardView: {
        showKpi: true,
        showChart: false,
      },
      statistic: null,
      isFirstLoad: true,
    }
  },
  created() {
  },
  mounted() {
    this.restoreDashboardViewSettings();
    this.loadDataStatistic();
  },
  methods: {
    restoreDashboardViewSettings() {
      try {
        const raw = localStorage.getItem("dashboard.device.view");
        if (!raw) {
          return;
        }
        const parsed = JSON.parse(raw);
        const showKpi = parsed && parsed.showKpi !== false;
        const showChart = parsed && parsed.showChart !== false;
        this.dashboardView.showKpi = showKpi;
        this.dashboardView.showChart = showChart;
        if (!this.dashboardView.showKpi && !this.dashboardView.showChart) {
          this.dashboardView.showKpi = true;
          this.dashboardView.showChart = true;
        }
      } catch (e) {
        this.dashboardView.showKpi = true;
        this.dashboardView.showChart = true;
      }
    },
    saveDashboardViewSettings() {
      localStorage.setItem("dashboard.device.view", JSON.stringify(this.dashboardView));
    },
    toggleDashboardSection(field, checked) {
      const next = {
        showKpi: this.dashboardView.showKpi,
        showChart: this.dashboardView.showChart,
      };
      next[field] = checked;

      // Always keep at least one section visible.
      if (!next.showKpi && !next.showChart) {
        return;
      }
      this.dashboardView.showKpi = next.showKpi;
      this.dashboardView.showChart = next.showChart;
      this.saveDashboardViewSettings();
    },
    loadDataStatistic: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/dashboard/statistic",
        dataSubmit() {
          return {
            fromDate: that.$helper.formatDate(that.dateRange.start),
            toDate: that.$helper.formatDate(that.dateRange.end),
            locationCode: that.locationCode.data.model
          }
        },
        isJsonContentType: false,
        ignoreDefaultData: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.statistic = response.data.data;
            that.isFirstLoad = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentConnect() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalConnect != null ? (this.statistic.devices.totalConnect / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentDisConnect() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalDisconnect != null ? (this.statistic.devices.totalDisconnect / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentActive() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalActive != null ? (this.statistic.devices.totalActive / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentInactive() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalInactive != null ? (this.statistic.devices.totalInactive / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentPause() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalPause != null ? (this.statistic.devices.totalPause / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    deviceKpis() {
      if (!this.statistic || !this.statistic.devices) {
        return [];
      }
      const d = this.statistic.devices;
      const total = Number(d.total) || 0;
      const pct = (n) => {
        if (!total) {
          return 0;
        }
        return Number((((Number(n) || 0) / total) * 100).toFixed(1));
      };
      return [
        {
          key: "connect",
          label: "Đang kết nối",
          value: Number(d.totalConnect) || 0,
          pct: pct(d.totalConnect),
          icon: "fa-rss",
          variant: "success",
          progressClass: "bg-success",
        },
        {
          key: "disconnect",
          label: "Mất kết nối",
          value: Number(d.totalDisconnect) || 0,
          pct: pct(d.totalDisconnect),
          icon: "fa-unlink",
          variant: "danger",
          progressClass: "bg-danger",
        },
        {
          key: "active",
          label: "Đang phát sóng",
          value: Number(d.totalActive) || 0,
          pct: pct(d.totalActive),
          icon: "fa-play",
          variant: "info",
          progressClass: "bg-info",
        },
        {
          key: "pause",
          label: "Tạm dừng phát sóng",
          value: Number(d.totalPause) || 0,
          pct: pct(d.totalPause),
          icon: "fa-pause-circle",
          variant: "warning",
          progressClass: "bg-warning",
        },
        {
          key: "inactive",
          label: "Không phát sóng",
          value: Number(d.totalInactive) || 0,
          pct: pct(d.totalInactive),
          icon: "fa-stop-circle",
          variant: "muted",
          progressClass: "bg-secondary",
        },
      ];
    },
    chartConnectionLabels() {
      return ["Đang kết nối", "Mất kết nối"];
    },
    chartConnectionDatasets() {
      const d = this.statistic && this.statistic.devices;
      const connect = d ? Number(d.totalConnect) || 0 : 0;
      const disconnect = d ? Number(d.totalDisconnect) || 0 : 0;
      return [
        {
          backgroundColor: ["#2eb85c", "#e55353"],
          borderColor: "#ffffff",
          borderWidth: 2,
          hoverBorderColor: "#ffffff",
          data: [connect, disconnect],
        },
      ];
    },
    chartBroadcastLabels() {
      return ["Đang phát sóng", "Tạm dừng phát sóng", "Không phát sóng"];
    },
    chartBroadcastDatasets() {
      const d = this.statistic && this.statistic.devices;
      const active = d ? Number(d.totalActive) || 0 : 0;
      const pause = d ? Number(d.totalPause) || 0 : 0;
      const inactive = d ? Number(d.totalInactive) || 0 : 0;
      return [
        {
          backgroundColor: ["#39f", "#f9b115", "#73818f"],
          borderColor: "#ffffff",
          borderWidth: 2,
          hoverBorderColor: "#ffffff",
          data: [active, pause, inactive],
        },
      ];
    },
    connectionStats() {
      const d = this.statistic && this.statistic.devices ? this.statistic.devices : {};
      return [
        { key: "connect", label: "Đang kết nối", value: Number(d.totalConnect) || 0, pct: this.getPercentConnect || 0, color: "#2eb85c" },
        { key: "disconnect", label: "Mất kết nối", value: Number(d.totalDisconnect) || 0, pct: this.getPercentDisConnect || 0, color: "#e55353" },
      ];
    },
    broadcastStats() {
      const d = this.statistic && this.statistic.devices ? this.statistic.devices : {};
      return [
        { key: "active", label: "Đang phát", value: Number(d.totalActive) || 0, pct: this.getPercentActive || 0, color: "#39f" },
        { key: "pause", label: "Tạm dừng", value: Number(d.totalPause) || 0, pct: this.getPercentPause || 0, color: "#f9b115" },
        { key: "inactive", label: "Không phát", value: Number(d.totalInactive) || 0, pct: this.getPercentInactive || 0, color: "#73818f" },
      ];
    },
    chartDoughnutOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { left: 4, right: 4, top: 8, bottom: 4 },
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            padding: 10,
            fontSize: 12,
            boxWidth: 10,
            fontColor: "#5c6873",
          },
        },
        tooltips: {
          bodyFontSize: 12,
          xPadding: 10,
          yPadding: 8,
          callbacks: {
            label(tooltipItem, data) {
              const labels = data.labels || [];
              const label = labels[tooltipItem.index] || "";
              const values = (data.datasets[0] && data.datasets[0].data) || [];
              const value = Number(values[tooltipItem.index]) || 0;
              const total = values.reduce((a, b) => a + (Number(b) || 0), 0);
              const pct = total ? ((value / total) * 100).toFixed(1) : "0.0";
              return ` ${label}: ${value} (${pct}%)`;
            },
          },
        },
        cutoutPercentage: 58,
        animation: {
          animateRotate: true,
          animateScale: false,
        },
      };
    },
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataStatistic();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = ''
      this.locationCode.data.model = this.districtCodeInput.data.model;
      if (!this.isFirstLoad) {
        this.loadDataStatistic();
      }
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      if (!this.isFirstLoad) {
        this.loadDataStatistic();
      }
    },
  }
}
</script>

<style scoped>
/* —— Thiết bị: header —— */
.dashboard-device-card {
  border-radius: 0.5rem !important;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.06) !important;
}

.dashboard-device-header {
  padding-top: 1.1rem !important;
}

.dashboard-device-header-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.dashboard-device-header-main {
  display: flex;
  align-items: center;
}

.dashboard-device-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(57, 162, 255, 0.18), rgba(57, 162, 255, 0.06));
  color: #39f;
  font-size: 1.25rem;
}

.dashboard-device-total-badge {
  font-size: 0.98rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.dashboard-device-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.dashboard-device-visibility-panel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);
}

.dashboard-device-toggle-item {
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dashboard-device-toggle-item input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.dashboard-toggle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
}

.dashboard-device-toggle-item:hover {
  background: rgba(59, 130, 246, 0.08);
  color: #2563eb;
}

.dashboard-device-toggle-item input[type="checkbox"]:checked + .dashboard-toggle-icon {
  color: #1d4ed8;
}

.dashboard-device-toggle-item.is-active {
  background: rgba(59, 130, 246, 0.14);
  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.35);
}

/* —— KPI grid —— */
.dashboard-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
}

.dashboard-kpi-tile {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 12px 10px;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fbfcfe;
  min-height: 96px;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.dashboard-kpi-tile:hover {
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.07);
  transform: translateY(-1px);
}

.dashboard-kpi-tile--success {
  border-left: 3px solid #2eb85c;
}
.dashboard-kpi-tile--danger {
  border-left: 3px solid #e55353;
}
.dashboard-kpi-tile--info {
  border-left: 3px solid #39f;
}
.dashboard-kpi-tile--warning {
  border-left: 3px solid #f9b115;
}
.dashboard-kpi-tile--muted {
  border-left: 3px solid #73818f;
}

.dashboard-kpi-tile__icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.dashboard-kpi-tile--success .dashboard-kpi-tile__icon {
  background: rgba(46, 184, 92, 0.12);
  color: #2eb85c;
}
.dashboard-kpi-tile--danger .dashboard-kpi-tile__icon {
  background: rgba(229, 83, 83, 0.12);
  color: #e55353;
}
.dashboard-kpi-tile--info .dashboard-kpi-tile__icon {
  background: rgba(57, 162, 255, 0.12);
  color: #39f;
}
.dashboard-kpi-tile--warning .dashboard-kpi-tile__icon {
  background: rgba(249, 177, 21, 0.15);
  color: #d69a0b;
}
.dashboard-kpi-tile--muted .dashboard-kpi-tile__icon {
  background: rgba(115, 129, 143, 0.12);
  color: #73818f;
}

.dashboard-kpi-tile__body {
  min-width: 0;
  flex: 1;
}

.dashboard-kpi-tile__label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8a93a2;
  line-height: 1.2;
  margin-bottom: 4px;
}

.dashboard-kpi-tile__value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3c4c;
  line-height: 1.2;
}

.dashboard-kpi-tile__pct {
  font-size: 0.9rem;
  font-weight: 500;
  color: #8a93a2;
  margin-left: 2px;
}

.dashboard-kpi-tile__bar {
  height: 4px;
  margin-top: 8px;
  border-radius: 4px;
  background: rgba(15, 23, 42, 0.06);
}

.dashboard-kpi-tile__bar .progress-bar {
  border-radius: 4px;
}

/* —— Chart panels —— */
.dashboard-chart-panel {
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
  padding: 0;
  overflow: visible;
}

.dashboard-chart-panel__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 10px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.05);
}

.dashboard-chart-panel__badge {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.dashboard-chart-panel__badge--conn {
  background: linear-gradient(135deg, rgba(46, 184, 92, 0.2), rgba(46, 184, 92, 0.08));
  color: #2eb85c;
}

.dashboard-chart-panel__badge--cast {
  background: linear-gradient(135deg, rgba(57, 162, 255, 0.22), rgba(57, 162, 255, 0.08));
  color: #39f;
}

.dashboard-chart-panel__title {
  font-weight: 700;
  font-size: 1.05rem;
  color: #2c3c4c;
  line-height: 1.25;
}

.dashboard-chart-panel__subtitle {
  font-size: 0.9rem;
  color: #8a93a2;
  margin-top: 2px;
  line-height: 1.3;
}

.dashboard-chart-panel__canvas {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 240px;
  padding: 6px 10px 6px;
}

.dashboard-chart-panel__body {
  display: grid;
  grid-template-columns: minmax(250px, 1.1fr) minmax(210px, 0.9fr);
  align-items: center;
  gap: 8px;
  width: 100%;
}

.dashboard-chart-panel__donut {
  position: relative;
  height: 190px;
  max-width: 300px;
  margin: 0 auto;
}

.dashboard-chart-panel__donut ::v-deep canvas {
  width: 100% !important;
  height: 100% !important;
}

.dashboard-chart-panel__stats {
  border-left: 1px dashed rgba(15, 23, 42, 0.12);
  padding-left: 12px;
  padding-top: 0;
  padding-bottom: 0;
}

.dashboard-stat-row {
  display: grid;
  grid-template-columns: 10px minmax(80px, 1fr) auto auto;
  align-items: center;
  gap: 8px;
  padding: 7px 0;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.dashboard-stat-row:last-child {
  border-bottom: none;
}

.dashboard-stat-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

.dashboard-stat-label {
  font-size: 0.92rem;
  color: #5c6873;
  white-space: normal;
}

.dashboard-stat-value {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2c3c4c;
}

.dashboard-stat-pct {
  font-size: 0.88rem;
  color: #8a93a2;
}

@media (max-width: 1199.98px) {
  .dashboard-chart-panel__body {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .dashboard-chart-panel__stats {
    border-left: none;
    border-top: 1px dashed rgba(15, 23, 42, 0.12);
    padding-left: 0;
    padding-top: 6px;
  }

  .dashboard-chart-panel__donut {
    height: 180px;
    max-width: 260px;
  }
}

@media (max-width: 575.98px) {
  .dashboard-device-header-row {
    flex-wrap: nowrap;
    align-items: center;
  }

  .dashboard-device-header-main {
    min-width: 0;
    flex: 1;
  }

  .dashboard-device-header-main .dashboard-device-header-icon {
    margin-right: 10px !important;
  }

  .dashboard-device-header-main h5 {
    font-size: 1.05rem;
    line-height: 1.1;
    margin-bottom: 0 !important;
  }

  .dashboard-device-header-main p {
    font-size: 0.78rem !important;
    margin-top: 2px !important;
  }

  .dashboard-device-header-actions {
    flex: 0 0 auto;
    margin-left: 8px;
  }

  .dashboard-device-visibility-panel {
    gap: 4px;
    padding: 3px;
  }

  .dashboard-device-toggle-item {
    width: 30px;
    height: 30px;
  }
}
</style>
